import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core';
import Icon from '@material-ui/icons/Error';
import { StyleRules } from '@material-ui/core/styles';
import HtmlToolTip from './HtmlToolTip';

type CssClasses = 'label' | 'required' | 'error' | 'fieldLabel' | 'icon';
const styles: StyleRules<CssClasses> = {
  fieldLabel: {
    marginRight: '5px',
    marginTop: '18px',
    marginBottom: '12px',
  },
  label: {
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    color: 'rgb(102, 102, 102)',
    fontSize: '15px',
    fontWeight: 700,
    webkitFontSmoothing: 'antialiased',
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: '19.5px',
  },
  required: {
    fontWeight: 'bold',
    margin: 0,
    color: '#d50000',
  },
  error: {
    color: '#d50000',
    fontSize: '14px',
    margin: '4px 0 0 0',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '4px',
    color: 'inherit',
  },
};

interface OwnProps {
  text: string;
  required?: boolean;
  small?: boolean;
  error?: boolean;
  errorText?: any;
  largeError?: boolean;
  toolTipHtml?: string;
}

type Props = OwnProps;

const FieldLabel = ({
  classes,
  text,
  required,
  error,
  errorText,
  toolTipHtml,
  largeError = true,
}: Props & WithStyles<CssClasses>) => (
  <div className={classes.fieldLabel}>
    <label className={classes.label}>
      {text}
      {required && <span className={classes.required}>*</span>}
      {error && !largeError && <span className={classes.error}>{errorText}</span>}
      {toolTipHtml && <HtmlToolTip html={toolTipHtml} />}
    </label>
    {error &&
      largeError && (
        <p className={classes.error}>
          <Icon className={classes.icon} fontSize="small" />
          {errorText}
        </p>
      )}
  </div>
);

export default withStyles(styles)(FieldLabel);



// WEBPACK FOOTER //
// ./src/components/FieldLabel.tsx